import React from "react";
import HeroSection from "../components/Blogs/HeroSection";
import News from "../components/Blogs/News";
import Sustainability from "../components/Blogs/Sustainability";
import Brands from "../components/Blogs/Brands";

const Blog = () => {
  return (
    <>
      <HeroSection />
      <News />
      <Sustainability />
      <Brands />
    </>
  );
};

export default Blog;
